// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAdukXmo5uhsGxIVdgAcFFk0-4ZutNwk5E",
  authDomain: "simpl-99331.firebaseapp.com",
  projectId: "simpl-99331",
  storageBucket: "simpl-99331.firebasestorage.app",
  messagingSenderId: "502103159323",
  appId: "1:502103159323:web:6a17b6edd637973ee63ebe",
  measurementId: "G-CXRNH4WRGF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

export const functions = getFunctions(app, 'us-central1');

export default app;
